"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    session_id: zod_1.z.string().uuid().optional(),
    message: zod_1.z.string().optional(),
    user_info: zod_1.z
        .object({
        available_pests: zod_1.z.record(zod_1.z.string(), zod_1.z.tuple([zod_1.z.number(), zod_1.z.string()])).optional(),
        available_properties: zod_1.z.record(zod_1.z.string(), zod_1.z.number()).optional(),
        available_views: zod_1.z.array(zod_1.z.string()).optional(),
        default_end_date: zod_1.z.string().datetime().optional(),
        default_start_date: zod_1.z.string().datetime().optional(),
        default_property: zod_1.z.number().optional(),
        current_date: zod_1.z.string().datetime().optional(),
    })
        .optional(),
});
exports.path = '/alma-chat-llm';
//# sourceMappingURL=index.js.map